import { render, staticRenderFns } from "./px-modal-message.vue?vue&type=template&id=49c9168c&scoped=true&"
import script from "./px-modal-message.vue?vue&type=script&lang=ts&"
export * from "./px-modal-message.vue?vue&type=script&lang=ts&"
import style0 from "./px-modal-message.vue?vue&type=style&index=0&id=49c9168c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9168c",
  null
  
)

export default component.exports